import React from "react";
import { ButtonBase, Paper, Stack, Typography, Radio } from "@mui/material";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import KeyboardArrowUpRoundedIcon from "@mui/icons-material/KeyboardArrowUpRounded";
import Image from "next/image";

/**
 * ChoiceOption - A selectable card option
 */
export default function ChoiceOption({
  label,
  description,
  selected,
  onClick,
  disabled,
  icon,
  endAdornment = "radio", // 'radio' | 'chevron' | 'check'
  expanded = false, // Controls arrow direction for chevron
}) {
  return (
    <ButtonBase
      onClick={onClick}
      disabled={disabled}
      className={`w-full text-left rounded-xl focus:outline-none ${
        disabled ? "opacity-50" : ""
      }`}
    >
      <Paper
        variant="outlined"
        className={`w-full rounded-xl px-4 py-3 md:px-5 md:py-4 border transition-all ${
          selected
            ? "border-blue-500 ring-2 ring-blue-100 bg-white"
            : "border-slate-200 hover:border-slate-300 bg-white"
        }`}
      >
        <Stack
          direction="row"
          alignItems="center"
          spacing={2}
          className="w-full"
        >
          {/* Left icon in rounded square (only if provided) */}
          {icon ? (
            <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-blue-50 text-blue-600 p-1">
              <Image
                alt="College Aid Pro"
                priority={true}
                src={icon}
                width={50}
                height={50}
                sizes="(max-width: 640px) 128px, 250px"
                className="cursor-pointer h-8 sm:h-7 md:h-16 w-auto"
              />
            </div>
          ) : null}

          {/* Label and description */}
          <div className="flex-1">
            <Typography className="text-slate-800 font-medium">
              {label}
            </Typography>
            {description ? (
              <Typography variant="body2" className="text-slate-500 mt-0.5">
                {description}
              </Typography>
            ) : null}
          </div>

          {/* Right adornment */}
          <div className="pl-2">
            {endAdornment === "radio" && (
              <Radio
                checked={Boolean(selected)}
                color="primary"
                size="small"
                readOnly
              />
            )}
            {endAdornment === "chevron" &&
              (expanded ? (
                <KeyboardArrowUpRoundedIcon className="text-slate-400 relative -left-[8px]" />
              ) : (
                <KeyboardArrowDownRoundedIcon className="text-slate-400 relative -left-[8px]" />
              ))}
          </div>
        </Stack>
      </Paper>
    </ButtonBase>
  );
}
